<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'Pretendard';
    box-sizing: border-box;
    
}

.v-application {
  font-family: 'Pretendard', sans-serif !important;
}

@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Thin.ttf') format('truetype');
  font-weight: 100;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-ExtraLight.ttf') format('truetype');
  font-weight: 200;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Light.ttf') format('truetype');
  font-weight: 300;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Regular.ttf') format('truetype');
  font-weight: 400;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Medium.ttf') format('truetype');
  font-weight: 500;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-SemiBold.ttf') format('truetype');
  font-weight: 600;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Bold.ttf') format('truetype');
  font-weight: 700;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-ExtraBold.ttf') format('truetype');
  font-weight: 800;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Black.ttf') format('truetype');
  font-weight: 900;
}
</style>


// WEBPACK FOOTER //
// src/App.vue